import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";
import CloseMenu from "@assets/svg/closeMenu.svg?react";
import FirstStep from "@assets/svg/FirstStep.svg?react";
import FirstSlid from "@assets/svg/FirstSlid.svg?react";

import useBreakPoinst from "@hooks/useBreakPoinst";
import { useTranslation } from "react-i18next";
import {
  ModalWrapper,
  CloseButtonWrapper,
  CloseMenuIcon,
  CardContainer,
  ImageWrapper,
  ContentBox,
  Title,
  Description,
  SliderContainer,
  ActionContainer,
  StyledButton,
} from "./styles/FirstStepModal";
interface Props {
  open: boolean;
  onClose: () => void;
  handleNextModal?: () => void;
}

const FirstStepModal = ({ open, onClose, handleNextModal }: Props) => {
  const navigate = useNavigate();
  const { isPhone } = useBreakPoinst();
  const { t } = useTranslation();

  const handleClick = () => {
    onClose(); // closes current modal
    handleNextModal?.(); // triggers next step
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalWrapper $isPhone={isPhone}>
        <CloseButtonWrapper onClick={onClose} $isPhone={isPhone}>
          <CloseMenuIcon $isPhone={isPhone}>
            <CloseMenu />
          </CloseMenuIcon>
        </CloseButtonWrapper>

        <CardContainer $isPhone={isPhone}>
          <ContentBox $isPhone={isPhone}>
            <Title $isPhone={isPhone}>
              {t("onBoardingJourny.increasePropertyReach")}
            </Title>
            <Description $isPhone={isPhone}>
              {t("onBoardingJourny.selectPlatformToConnect")}
            </Description>
          </ContentBox>
          <ImageWrapper $isPhone={isPhone}>
            <FirstStep width={527.78} height={252.68} />
          </ImageWrapper>
        </CardContainer>

        <ContentBox $isPhone={isPhone}>
          <Title $isPhone={isPhone}>{t("onBoardingJourny.firstStep")}</Title>
          <Description $isPhone={isPhone}>
            {t("onBoardingJourny.goToConnectionProvider")}
          </Description>
        </ContentBox>

        <SliderContainer $isPhone={isPhone}>
          <FirstSlid height="12px" width="100%" />
        </SliderContainer>

        <ActionContainer $isPhone={isPhone}>
          <StyledButton
            onClick={handleClick}
            $TextColor="white"
            $BgColor="#5B3FFF"
            $isPhone={isPhone}
            $width="127px"
          >
            {t("onBoardingJourny.connectAccount")}
          </StyledButton>
        </ActionContainer>
      </ModalWrapper>
    </Modal>
  );
};

export default FirstStepModal;
